import { Flag, Trophy } from "lucide-react";

// Shown for the last 3 weeks of a season, then "Season complete" once the last play date passes.
export const SeasonCountdown = ({ week, testid }) => {
  if (!week) return null;
  const left = week.total - week.current + 1;
  if (!week.complete && left > 3) return null;
  const label = week.complete ? "Season complete" : left <= 1 ? "Final week" : `${left} weeks left`;
  const Icon = week.complete ? Trophy : Flag;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide px-2 py-1 rounded-full whitespace-nowrap ${
        week.complete ? "bg-gray-100 text-gray-600" : "bg-[var(--div-accent)] text-white"
      }`}
    >
      <Icon className="h-3 w-3 shrink-0" /> {label}
    </span>
  );
};
